import Radio from "backbone.radio";
import { View } from 'backbone.marionette';
import { Model } from 'backbone';
import './index.styl';
import { Secret } from "../../utils";
const appViewChannel = Radio.channel('appView');

class CoreFooterView extends View {

	get className() {
		return 'site-footer';
	}

	initialize() {
		this.model = new Model({
			IS_PRE_SEASON: Secret.is_passed ? false : JSON.parse(process.env.IS_PRE_SEASON)
		});
		this.listenTo( appViewChannel, 'hide', this.destroy );
	}
}

export default CoreFooterView;